import { useEffect, useLayoutEffect, useRef, useState } from 'react';

const useSpotlight = () => {
  const [load, setLoad] = useState(false);
  const targetRef = useRef<HTMLDivElement>(null);
  const [{ height, width }, setClientSize] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  });

  useLayoutEffect(() => {
    setLoad(true);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const { innerWidth: width, innerHeight: height } = window;
      setClientSize({ width, height });
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { load, targetRef, height, width };
};

export default useSpotlight;
